import { render, staticRenderFns } from "./AreaDialog.vue?vue&type=template&id=6577444e&scoped=true"
import script from "./AreaDialog.vue?vue&type=script&lang=js"
export * from "./AreaDialog.vue?vue&type=script&lang=js"
import style0 from "./AreaDialog.vue?vue&type=style&index=0&id=6577444e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6577444e",
  null
  
)

export default component.exports